// Small shared hooks. Owner: WP04.
import { useEffect, useState, useSyncExternalStore } from 'react';

/** Live CSS media query match (e.g. '(max-width: 768px)'). */
export function useMediaQuery(query: string): boolean {
  return useSyncExternalStore(
    (cb) => {
      if (typeof matchMedia !== 'function') return () => {};
      const m = matchMedia(query);
      m.addEventListener('change', cb);
      return () => m.removeEventListener('change', cb);
    },
    () => (typeof matchMedia === 'function' ? matchMedia(query).matches : false),
    () => false,
  );
}

/** Mobile layout breakpoint used across the app (bottom navigation, sheets, list guide). */
export const MOBILE_QUERY = '(max-width: 768px)';
export const useIsMobile = () => useMediaQuery(MOBILE_QUERY);

/** Current time, re-rendering every `intervalMs` (aligned to the interval boundary). */
export function useNow(intervalMs = 30_000): number {
  const [now, setNow] = useState(() => Date.now());
  useEffect(() => {
    let t: ReturnType<typeof setTimeout>;
    const tick = () => { setNow(Date.now()); t = setTimeout(tick, intervalMs - (Date.now() % intervalMs)); };
    t = setTimeout(tick, intervalMs - (Date.now() % intervalMs));
    return () => clearTimeout(t);
  }, [intervalMs]);
  return now;
}
